!(function () {
  "use strict";
  customElements.get("share-button") ||
    customElements.define(
      "share-button",
      class extends HTMLElement {
        constructor() {
          (super(),
            (this.container = this.closest("[data-section-type]")),
            (this.shareButton = this.querySelector("[data-share-button]")),
            (this.tooltip = this.querySelector("tooltip-component")));
        }
        connectedCallback() {
          this.shareButton &&
            ((this.urlToShare =
              this.shareButton.dataset.shareLink || document.location.href),
            navigator.share
              ? this.shareButton.addEventListener("click", () => {
                  navigator.share({
                    url: this.urlToShare,
                    title: document.title,
                  });
                })
              : this.shareButton.addEventListener(
                  "click",
                  this.copyToClipboard.bind(this),
                ));
        }
        copyToClipboard() {
          navigator.clipboard.writeText(this.urlToShare).then(() => {
            ("function" == typeof this.tooltip?.addPinEvent &&
              this.tooltip.addPinEvent(),
              setTimeout(() => window.theme.closeAllTooltips(), 1500));
          });
        }
        updateUrl(t) {
          t && (this.urlToShare = t);
        }
      },
    );
})();
